import { Controller } from '@hotwired/stimulus'

export default class ToggleClassOnViewportIntersectionController extends Controller {
  static values = {
    rootMargin: { type: String, default: '0px' },
    className: { type: String, default: 'intersecting' },
    threshold: { type: Array, default: [0] }
  }

  connect = () => {
    this.observer = new IntersectionObserver(this.intersectionCallback,
      { threshold: this.thresholdValue, rootMargin: this.rootMarginValue })

    this.observer.observe(this.element)
  }

  disconnect = () => {
    this.observer.disconnect()
  }

  intersectionCallback = (entries) => {
    entries.forEach(entry => {
      entry.target.classList.toggle(this.classNameValue, entry.isIntersecting)
    })
  }
}
